/*
* 异常统计上报
* */
import { request } from './request.js';
import { BOM } from './BOM.js';
import { getPokeUser,isNative,trackServer } from './utils.js';

let now = null;

function _log(data,proxy=true) {
    const _pokeUser = getPokeUser();
    if (!data.uid) {
        data.uid = _pokeUser.uid || 'nologin';
    }
    if(isNative() && proxy){
        if(data.event && data.label){
            trackServer({
                event:data.event,
                label:data.label,
                extra:data.extra || {},
                value:BOM.window.location.href
            });
            return ;
        }
    }
    request({
        url: '/webkara/log',
        json: true,
        log: false,
        error: () => {},
        crossOrigin: false,
        method: 'post',
        needNetworkError: false,
        data: data
    });
}

let Performance = {
    timing: function(pageName) {
        if (typeof performance != 'undefined') {
            let timing = performance.timing;
            let _browserLaunching = timing.fetchStart - timing.navigationStart;
            let _preWaiting = timing.requestStart - timing.fetchStart;
            let _waitingServer = timing.responseStart - timing.requestStart;
            let _delivering = timing.responseEnd - timing.responseStart;
            let _whiteScreenTime = timing.domContentLoadedEventEnd - timing.domLoading;
            //let _loadTime=timing.loadEventEnd-timing.domLoading;
            let param = {
                pageName: pageName || '',
                event: 'timing',
                type: 'performance',
                browserLaunching: _browserLaunching,
                preWaiting: _preWaiting,
                waitingServer: _waitingServer,
                delivering: _delivering,
                whiteScreenTime: _whiteScreenTime
            };
            try {
                let timeTotal =
                    _browserLaunching +
                    _preWaiting +
                    _waitingServer +
                    _delivering +
                    _whiteScreenTime;
                if (timeTotal > 10000) {
                    param.type = 'error';
                    param.url = BOM.window.location.href;
                }
                _log(param);
            } catch (e) {
                //_log(param);
            }
        }
    },
    error: function(e, event) {
        let _now = new Date().getTime();
        //避免频繁发送
        if (now && _now - now < 1000) {
            return;
        }
        let _e;
        try {
            _e = JSON.stringify(e, ['message', 'type', 'isTrusted', 'error', 'filename']);
        } catch (ce) {
            _e = e;
        }
        const data = {
            event: 'pokeScriptError',
            type: 'error',
            e: _e
        };
        if (event) {
            data.event = event;
        }
        _log(data);
        now = _now;
    },
    log: _log
};
export { Performance };
